import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/Video`
//#region select数据源相关api
const GetInfo = (id: number) => `${apiUrl}/${id}`
const GetList = `${apiUrl}`
const GetLogs = `${apiUrl}/logs`
const GetLogPoints = `${apiUrl}/logs/points`
const GetLogChart = `${apiUrl}/logs/chartData`
const Delete = (id: number) => `${apiUrl}/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const AddFocus = (id: number) => `${apiUrl}/focus/add/${id}`
const CancelFocus = (id: number) => `${apiUrl}/focus/cancel/${id}`
const GetFocusList = `${apiUrl}/focus`
const GetPointList = (id: number) => `${apiUrl}/points/${id}`
const GetPointData = (id: number) => `${apiUrl}/point/${id}`
const DeletePoint = (id: number) => `${apiUrl}/point/${id}`
const PutPointData = (videoId: number) => `${apiUrl}/point/${videoId}`
//监控点连接协议 TCP/UDP
const GetConnectProtocol = (type: number) => `${apiUrl}/point/connectProtocol/${type}`
const GetStorageTypeList = (type: number) => `${apiUrl}/point/storageType/${type}`
/**主子码流标识：0-主码流，1-子码流 */
const GetStreamMode = (type: number) => `${apiUrl}/point/streamMode/${type}`

//视频播放相关查询
const GetUnitList = `${apiUrl}/units`
const GetListByUnit = (unitId: number) => `${apiUrl}/byUnit/${unitId}`
const GetListByUnit2 = (unitId: number) => `${apiUrl}/byUnit/v2/${unitId}`
//#endregion

export const emptyData: VideoData = {
    Id: 0,
    UnitId: 0,
    DeviceNumber: '',
    DeviceName: '',
    SerialNumber: '',
    DriverName: '',
    DriverVersion: '',
    DeviceModel: '',
    UniqueCoding: '',
    Manufacturer: '',
    ProtocolId: 0,
    Description: '',
    AccessIP: '',
    AccessPort: '',
    AccessUser: '',
    AccessPwd: '',
    Status: 0,
    Online: 1,
    IsSourceDelete: false,

    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    UnitCode: '',
    UnitName: '',
    ProtocolName: '',
    UserName: '',
    PointList: []
}
export const emptyPoint: VideoPointData = {
    Id: 0,
    VideoId: 0,
    PointNumber: '',
    PointName: '',
    PointType: 0,
    ChannelNumber: '',
    ChannelType: 0,
    ConnectProtocol: '',
    StreamMode: 0,
    SeaHeight: 0,
    Longitude: 0,
    Latitude: 0,
    Status: 0,
    Online: 1,
    IsSourceDelete: false,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    PointTypeName: '',
    ChannelTypeName: '',
    StreamModeName: '',
    UserName: '',

    LngDegree: 0,
    LngSecond: 0,
    LngMinute: 0,

    LatDegree: 0,
    LatSecond: 0,
    LatMinute: 0
}
export interface VideoData {
    Id: number
    UnitId: number
    DeviceNumber: string
    DeviceName: string
    SerialNumber: string
    DriverName: string
    DriverVersion: string
    DeviceModel: string
    UniqueCoding: string
    Manufacturer: string
    ProtocolId: number
    Description: string
    AccessIP: string
    AccessPort: string
    AccessUser: string
    AccessPwd: string
    Status: number
    Online: number
    IsSourceDelete: boolean
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    UnitCode: string
    UnitName: string
    ProtocolName: string
    UserName: string
    PointList: VideoPointData[]
}
export interface VideoPointData {
    Id: number
    VideoId: number
    PointNumber: string
    PointName: string
    PointType: number
    ChannelNumber: string
    ChannelType: number
    ConnectProtocol: string
    StreamMode:number
    SeaHeight: number
    Longitude: number
    Latitude: number
    Status: number
    Online: number
    IsSourceDelete: boolean
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    PointTypeName: string
    ChannelTypeName: string
    StreamModeName: string
    UserName: string

    LngDegree: number
    LngSecond: number
    LngMinute: number

    LatDegree: number
    LatSecond: number
    LatMinute: number
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id)
    })
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getLogs = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetLogs,
        params: param
    })
}
export const getLogPoints = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetLogPoints,
        params: param
    })
}
export const getLogChart = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetLogChart,
        params: param
    })
}
export const remove = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const postData = (form: VideoData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: VideoData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
export const removePoint = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DeletePoint(id)
    })
}
export const getConnectProtocol = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetConnectProtocol(firstType)
    })
}
export const getStreamMode = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStreamMode(firstType)
    })
}
export const getStorageTypeList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStorageTypeList(firstType)
    })
}
export const getFocusList = () => {
    return tryAxios({
        method: 'get',
        url: GetFocusList
    })
}
export const addFocus = (id: number) => {
    return tryAxios({
        method: 'post',
        url: AddFocus(id)
    })
}
export const cancelFocus = (id: number) => {
    return tryAxios({
        method: 'post',
        url: CancelFocus(id)
    })
}
export const getPointList = (videoId: number) => {
    return tryAxios({
        method: 'get',
        url: GetPointList(videoId)
    })
}
export const getPointInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetPointData(id)
    })
}
export const putPointData = (videoId: number, form: VideoPointData) => {
    return tryAxios({
        method: 'put',
        url: PutPointData(videoId),
        data: form
    })
}

//视频播放相关api
export const getUnitList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetUnitList,
        params: param
    })
}
export const getListByUnit = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetListByUnit(unitId)
    })
}
export const getListByUnit2 = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetListByUnit2(unitId)
    })
}